import { useEffect, useState } from 'react';

function withOpenItemIds(base: string[], openItemIds: string[]): string[] {
  if (openItemIds.length === 0) return base;
  return [...new Set([...base, ...openItemIds])];
}

export function useAccordionValue({
  expandFirstItem,
  firstItemId,
  openItemIds = [],
}: {
  expandFirstItem: boolean;
  firstItemId: string | undefined;
  openItemIds?: string[];
}) {
  const [accordionValue, setAccordionValue] = useState<string[]>(() =>
    withOpenItemIds(expandFirstItem && firstItemId ? [firstItemId] : [], openItemIds),
  );

  useEffect(() => {
    setAccordionValue(expandFirstItem && firstItemId ? [firstItemId] : []);
  }, [expandFirstItem, firstItemId]);

  useEffect(() => {
    if (openItemIds.length === 0) return;
    setAccordionValue((prev) => withOpenItemIds(prev, openItemIds));
  }, [openItemIds]);

  return [accordionValue, setAccordionValue] as const;
}
